import * as React from 'react';
import { DataGrid, gridClasses, GridToolbar } from '@mui/x-data-grid';
import { useDemoData } from '@mui/x-data-grid-generator';
import { grey } from '@mui/material/colors';

export default function RowMarginGrid() {
    const { data } = useDemoData({
        dataSet: 'Commodity',
        rowLength: 200,
        maxColumns: 40,
    });

    const getRowSpacing = React.useCallback((params) => {
        return {
            top: params.isFirstVisible ? 0 : 5,
            bottom: params.isLastVisible ? 0 : 5,
        };
    }, []);

    return (
        <div style={{ height: 500, width: '100%' }}>
            <div style={{ display: 'flex', height: '100%' }}>
                <DataGrid
                    {...data}
                    disableSelectionOnClick
                    getRowSpacing={getRowSpacing}
                    components={{
                        Toolbar: GridToolbar,
                    }}
                    sx={{
                        [`& .${gridClasses.row}`]: {
                            bgcolor: (theme) =>
                                theme.palette.mode === 'light' ? grey[200] : grey[900],
                        },
                    }}
                />
            </div>
        </div>
    );
}
